export * from './selectors';

export declare type MinimalAction = {
  type: string;
};

export declare type Action = {
  payload: any;
  type: string;
  error?: any;
  meta?: {
    schema: any;
  };
};

export const initSagas = (sagas, sagaMiddleware) => {
  Object.values(sagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
};

export const createReducer = (initialState, handlers) => (state, actionC) => {
  if (state === void 0) {
    state = initialState;
  }
  if (Object.prototype.hasOwnProperty.call(handlers, actionC.type)) {
    return handlers[actionC.type](state, actionC);
  }
  return state;
};
